module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/main-visual-text-e128de4bbe49247f2ce938f938334094.png";